import React from 'react';

import {
  Container,
  BenefitsHeading,
  StyledValueIndicatorList,
} from './BookingBenefits.styled';
import { SliceLayout } from '../SliceLayout';
import { useIsDarkTheme } from '../../context/DarkThemeContext';

const benefitsList = [
  'Your payment is held safely until after your successful event',
  'Flexible monthly payment plan, with deposits from 10%',
  'Best in-class protection in the event of a cancellation',
  'Replacement supplier guarantee via Protect+',
];

const benefitsHeading = 'When you book with Togather';

export const BookingBenefits = () => {
  const isDark = useIsDarkTheme();

  return (
    <SliceLayout backgroundColor="lightGrey">
      <Container isDark={isDark}>
        <BenefitsHeading isDark={isDark}>{benefitsHeading}</BenefitsHeading>

        <StyledValueIndicatorList isDark={isDark} messages={benefitsList} />
      </Container>
    </SliceLayout>
  );
};
